export const EXISTING_COMPANY_SUFFIX = " (Already Exists)";

export function stripExistingCompanySuffix(value) {
  if (typeof value !== "string") return "";
  return value.replace(/ \(Already Exists\)$/, "").trim();
}

export function existingCompanyOptionValue(name) {
  return `${name}${EXISTING_COMPANY_SUFFIX}`;
}

export function normalizeCompanySuggestionNames(payload) {
  if (!Array.isArray(payload)) return [];
  return payload
    .map((item) => {
      if (typeof item === "string") return item;
      if (item && typeof item === "object") {
        return item.name ?? item.company_name ?? item.label ?? "";
      }
      return "";
    })
    .map((name) => String(name).trim())
    .filter(Boolean);
}

export function companyNamesMatch(left, right) {
  return left.trim().toLowerCase() === right.trim().toLowerCase();
}

export function companySuggestionPayload(body) {
  if (!body || typeof body !== "object") return [];
  if (Array.isArray(body.data)) return body.data;
  if (Array.isArray(body.data?.data)) return body.data.data;
  if (Array.isArray(body.suggestions)) return body.suggestions;
  if (Array.isArray(body.companies)) return body.companies;
  if (Array.isArray(body)) return body;
  return [];
}

export function extractCompanyLabelsFromTradingCompanies(rows) {
  if (!Array.isArray(rows)) return [];
  return rows
    .map((row) => row?.label ?? row?.name ?? row?.company_name ?? "")
    .map((name) => String(name).trim())
    .filter(Boolean);
}

/** Case-insensitive substring match; order of characters in the name does not matter for inclusion. */
export function filterCompanyNamesByQuery(allNames, query) {
  const q = query.trim().toLowerCase();
  if (!q) return [];
  return allNames.filter((name) => name.toLowerCase().includes(q));
}

export function mergeCompanySuggestionLists(...lists) {
  const seen = new Set();
  const merged = [];
  for (const list of lists) {
    for (const raw of list) {
      const name = String(raw ?? "").trim();
      if (!name) continue;
      const key = name.toLowerCase();
      if (seen.has(key)) continue;
      seen.add(key);
      merged.push(name);
    }
  }
  return merged;
}

/** True when the typed name matches an existing company in the suggestion list. */
export function hasExactCompanyMatch(name, suggestions) {
  const trimmed = stripExistingCompanySuffix(name);
  if (!trimmed) return false;
  return suggestions.some((item) => companyNamesMatch(item, trimmed));
}
